var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-pie',{ref:"chartPie",attrs:{"data":_vm.chartData,"extend":_vm.extend,"title":_vm.extend.title,"legend":_vm.extend.legend,"tooltip":_vm.extend.tooltip}})}
var staticRenderFns = []
export { render, staticRenderFns }